import styled from "styled-components";

export default styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 720px;
    padding: 16px;
    font-size: 13px;
    line-height: 1.45;

    p,
    ul {
        margin: 0;
    }

    ul {
        padding-left: 18px;
    }
`;
